export default "__VITE_ASSET__Cxr1t0cx__"